import React, { useEffect } from "react";
import "./NewShopLanding.scss";
import NewShopFeatured from "./NewShopFeatured";
import NewFilterMarcasHeader from "../filterMarcas/NewFilterMarcasHeader";
import NewLandingProductTable from "./NewLandingProductTable";

const sliderStep = (selector, dir = 1) => {
  const el = document.querySelector(selector);
  if (!el) return;
  const step = Math.round(el.clientWidth * 0.9);
  el.scrollBy({ left: dir * step, behavior: "smooth" });
};

function NewShopLanding({
  lstMarcas,
  handleSelectMarcaChange,
  handleInputChangeDescripcion,
  marcaSelect,
  descripcion,
  moneda,
  handleChangeTipoMoneda,
  islogin,
  NombreCompleto,
  handleLogout,
  handleEventUpdateBottomCarrito,
  updateBottomCarrito,
}) {
  const heroVideoUrl =
    (marcaSelect && marcaSelect.chrVideoUrl) ||
    "https://nyc3.digitaloceanspaces.com/eanet-media/tienda/The%20BMW%20M5%20_2020_.mp4";
  useEffect(() => {
    const buttons = Array.from(document.querySelectorAll("[data-slide]"));
    const handleClick = (evt) => {
      const btn = evt.currentTarget;
      const sel = btn.getAttribute("data-slide");
      const dir = parseInt(btn.getAttribute("data-dir"), 10) || 1;
      sliderStep(sel, dir);
    };
    buttons.forEach((btn) => btn.addEventListener("click", handleClick));
    return () => buttons.forEach((btn) => btn.removeEventListener("click", handleClick));
  }, []);

  useEffect(() => {
    const video = document.getElementById("heroVideo");
    if (!video) return;

    const tryPlayWithSound = async () => {
      try {
        video.muted = false;
        video.volume = 1;
        await video.play();
        return true;
      } catch (_) {
        return false;
      }
    };

    const autoUnmute = async () => {
      try {
        video.muted = false;
        video.volume = 1;
        await video.play();
      } catch (_) {
        /* navegador bloqueó el audio */
      }
      window.removeEventListener("pointerdown", autoUnmute, true);
      window.removeEventListener("keydown", autoUnmute, true);
      window.removeEventListener("touchstart", autoUnmute, true);
    };

    (async () => {
      const ok = await tryPlayWithSound();
      if (!ok) {
        try {
          video.muted = true;
          await video.play();
        } catch (_) {
          /* ignore */
        }
        window.addEventListener("pointerdown", autoUnmute, true);
        window.addEventListener("keydown", autoUnmute, true);
        window.addEventListener("touchstart", autoUnmute, true);
      }
    })();

    return () => {
      window.removeEventListener("pointerdown", autoUnmute, true);
      window.removeEventListener("keydown", autoUnmute, true);
      window.removeEventListener("touchstart", autoUnmute, true);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("nl-page-body");
    return () => document.body.classList.remove("nl-page-body");
  }, []);

  return (
    <main className="nl-page">
      <NewFilterMarcasHeader
        lstMarcas={lstMarcas}
        handleSelectMarcaChange={handleSelectMarcaChange}
        handleInputChangeDescripcion={handleInputChangeDescripcion}
        marcaSelect={marcaSelect}
        descripcion={descripcion}
        moneda={moneda}
        handleChangeTipoMoneda={handleChangeTipoMoneda}
        islogin={islogin}
        NombreCompleto={NombreCompleto}
        handleLogout={handleLogout}
        handleEventUpdateBottomCarrito={handleEventUpdateBottomCarrito}
        updateBottomCarrito={updateBottomCarrito}
      />
      <div className="nl-hero">
        <video
          key={heroVideoUrl}
          id="heroVideo"
          className="nl-hero-video"
          autoPlay
          playsInline
          loop
          preload="auto"
          src={heroVideoUrl}
        >
          Tu navegador no soporta video HTML5.
        </video>
      </div>

      <NewLandingProductTable
        marcaSelect={marcaSelect}
        moneda={moneda}
        handleEventUpdateBottomCarrito={handleEventUpdateBottomCarrito}
      />

      <section className="nl-section">
        <div className="nl-container">
          <NewShopFeatured />
        </div>
      </section>

      <section id="lifestyle" className="nl-section">
        <div className="nl-container">
          <div className="nl-grid nl-grid--split">
            <div>
              <p className="nl-eyebrow">Estilo de vida y ropa</p>
              <h2 className="nl-title">ERES TODO TU</h2>
            </div>
            <div>
              <p className="nl-lead">
                Auténtico estilo de vida BMW para cada momento, diseñado con esmero y precisión. Piensa en ajustes equilibrados,
                diseños impecables y la calidad superior de BMW.
              </p>
            </div>
          </div>

          <div className="nl-actions-row">
            <button className="nl-pill nl-pill--solid">Colecciones BMW</button>
            <button className="nl-pill nl-pill--ghost">Accesorios y regalos</button>
            <button className="nl-pill nl-pill--ghost">Vestir</button>
          </div>

          <div className="nl-media">
            <img
              src="https://nyc3.digitaloceanspaces.com/eanet-media/tienda/514665230_24448092421441817_3103637117219217726_n.jpg"
              alt="Accesorios y estilo BMW"
            />
          </div>
        </div>
      </section>

      <section id="categoria-extra" className="nl-section">
        <div className="nl-container">
          <div className="nl-section__head">
            <h2 className="nl-title nl-title--small">Accesorios BMW</h2>
            <a href="#" className="nl-section__link">
              Ver todo
            </a>
          </div>
          <div className="nl-carousel-wrapper">
            <button
              aria-label="Anterior accesorios"
              className="nl-slider-btn nl-slider-btn--left"
              data-slide="#slider-accesorios"
              data-dir="-1"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="24" height="24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m15 19-7-7 7-7" />
              </svg>
            </button>
            <div id="slider-accesorios" className="nl-carousel">
              <article className="nl-card">
                <div className="nl-card__img-wrap">
                  <img
                    src="https://s3.amazonaws.com/static.revolutionparts.com/assets/themes/default_assets/image-three.jpg"
                    alt="Llavero BMW"
                    className="nl-card__img"
                  />
                </div>
                <h3 className="nl-card__title">Llavero BMW M</h3>
                <p className="nl-card__meta">Edición especial</p>
              </article>
              <article className="nl-card">
                <div className="nl-card__img-wrap">
                  <img
                    src="https://images.unsplash.com/photo-1525609004556-c46c7d6cf023?q=80&w=1200&auto=format&fit=crop"
                    alt="Gorra BMW"
                    className="nl-card__img"
                  />
                </div>
                <h3 className="nl-card__title">Gorra Motorsport</h3>
                <p className="nl-card__meta">Algodón premium</p>
              </article>
              <article className="nl-card">
                <div className="nl-card__img-wrap">
                  <img
                    src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?q=80&w=1200&auto=format&fit=crop"
                    alt="Audífonos"
                    className="nl-card__img"
                  />
                </div>
                <h3 className="nl-card__title">Auriculares BMW</h3>
                <p className="nl-card__meta">Bluetooth</p>
              </article>
              <article className="nl-card">
                <div className="nl-card__img-wrap">
                  <img
                    src="https://s3.amazonaws.com/static.revolutionparts.com/assets/themes/default_assets/image-three.jpg"
                    alt="Termo"
                    className="nl-card__img"
                  />
                </div>
                <h3 className="nl-card__title">Termo BMW</h3>
                <p className="nl-card__meta">Acero inoxidable</p>
              </article>
            </div>
            <button
              aria-label="Siguiente accesorios"
              className="nl-slider-btn nl-slider-btn--right"
              data-slide="#slider-accesorios"
              data-dir="1"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="24" height="24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m9 5 7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      <section id="dealer" className="nl-section nl-section--plain">
        <div className="nl-container">
          <div className="nl-info">
            <div>
              <div className="nl-media">
                <img
                  src="https://nyc3.digitaloceanspaces.com/eanet-media/tienda/bmw-vehicle-checks.jpg"
                  alt="Instalaciones servicio BMW"
                />
              </div>
              <h3 className="nl-subtitle">EANET MOTRIX PIQ DE BMW Y MINI</h3>
            </div>
            <div>
              <h4 className="nl-title nl-title--small">Ubícanos:</h4>
              <div className="nl-info__card">
                <div className="nl-eyebrow">Contacto y soporte para pedidos</div>
                <div className="nl-info__links">
                  <a href="#">Ayuda con un pedido</a>
                  <a href="#">Contáctenos</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="nl-map">
          <iframe
            title="Mapa EANET MOTRIX"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=Av.+Libertad+386,+San+Miguel,+Lima&output=embed"
          ></iframe>

          <div className="nl-map__overlay">
            <a href="#" aria-label="Facebook" target="_blank" rel="noopener" className="nl-social">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M22 12.06C22 6.53 17.52 2 12 2S2 6.53 2 12.06c0 5 3.66 9.14 8.44 9.94v-7.03H8.08v-2.9h2.36V9.41c0-2.33 1.39-3.62 3.52-3.62 1.02 0 2.1.18 2.1.18v2.31h-1.18c-1.17 0-1.54.73-1.54 1.49v1.78h2.63l-.42 2.9h-2.21V22c4.78-.8 8.44-4.94 8.44-9.94Z" />
              </svg>
            </a>
            <a href="#" aria-label="X (Twitter)" target="_blank" rel="noopener" className="nl-social">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M18.244 2H21l-6.64 7.58L22 22h-6.828l-4.78-6.23L4.9 22H2.14l7.09-8.1L2 2h6.91l4.34 5.74L18.244 2Zm-2.39 18h1.83L8.24 4H6.35l9.5 16Z" />
              </svg>
            </a>
            <a href="#" aria-label="Instagram" target="_blank" rel="noopener" className="nl-social">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M12 2.2c3.2 0 3.584.012 4.85.07 1.17.054 1.97.24 2.67.51.73.28 1.35.66 1.95 1.26.6.6.98 1.22 1.26 1.95.27.7.45 1.5.51 2.67.06 1.27.07 1.65.07 4.85 0 3.2-.01 3.58-.07 4.85-.06 1.17-.24 1.97-.51 2.67-.28.73-.66 1.35-1.26 1.95-.6.6-1.22.98-1.95 1.26-.7.27-1.5.45-2.67.51-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.06-1.97-.24-2.67-.51-.73-.28-1.35-.66-1.95-1.26-.6-.6-.98-1.22-1.26-1.95-.27-.7-.45-1.5-.51-2.67C2.21 15.58 2.2 15.2 2.2 12s.01-3.58.07-4.85c.06-1.17.24-1.97.51-2.67.28-.73.66-1.35 1.26-1.95.6-.6 1.22-.98 1.95-1.26.7-.27 1.5-.45 2.67-.51C8.42 2.21 8.8 2.2 12 2.2Zm0 3.1a6.7 6.7 0 1 0 0 13.4 6.7 6.7 0 0 0 0-13.4Zm0 11a4.3 4.3 0 1 1 0-8.6 4.3 4.3 0 0 1 0 8.6Zm5.1-11.7a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6Z" />
              </svg>
            </a>
            <a href="#" aria-label="YouTube" target="_blank" rel="noopener" className="nl-social">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path d="M23.5 7.2s-.23-1.62-.94-2.33c-.9-.94-1.9-.94-2.36-.99C16.9 3.5 12 3.5 12 3.5h-.01s-4.9 0-8.2.38c-.46.05-1.47.05-2.36.99C.73 5.58.5 7.2.5 7.2S.25 9.15.25 11.1v1.79c0 1.95.25 3.9.25 3.9s.23 1.62.94 2.33c.9.94 2.08.91 2.61 1.01 1.89.18 8 .37 8 .37s4.9 0 8.2-.39c.46-.05 1.47-.05 2.36-.99.71-.71.94-2.33.94-2.33s.25-1.95.25-3.9V11.1c0-1.95-.25-3.9-.25-3.9ZM9.75 13.9v-5l5.2 2.5-5.2 2.5Z" />
              </svg>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default NewShopLanding;
